export const CHAT = {
  chat: {
    createNewChat: 'New chat',
    newChat: 'New chat',
    searchPlaceholder: 'Search',
    recentChats: 'Recent Chats',
    welcomeMessage: 'How can I help you today?',
    welcomeCaveat:
      'You are using an Artificial Intelligence (AI) equipped tool. Users are not communicating with a live safety professional, rather are communicating with an AI chatbot. The AI generated responses provided by Enstructure’s Safety Virtual Assistant are intended only for informational use. The information provided by the Enstructure Safety Virtual Assistant is not intended as, nor does it constitute, specific technical or legal advice to the user. AI tools, GPT’s or chatbots occasionally provide incorrect information. It is the user’s responsibility to validate the information provided and to use reasonable care when using the information provided. When in doubt, consult a member of Enstructure’s Safety Team for assistance.',
    loadingChats: 'Loading chats...',
    loadingMessages: 'Loading conversation...',
    promptPlaceholder: 'Ask anything...',
    deleteChat: 'Delete chat',
    disclaimer: 'AI can make mistakes. Always verify important information.',
    agentName: 'Safety Enstructure',
    thinking: 'Thinking',
    sources: 'Sources',
    pageAbbrev: 'p.',
    anonymousUser: 'Anonymous User',
    anonymousEmail: 'anonymousmail@email.com',
    imminentDanger: {
      question: "Is this a situation where someone's life is in imminent danger?",
      yes: 'Yes',
      no: 'No',
      emergencyMessage:
        'Stop work and immediately contact your supervisor, your terminal safety team or the Chief Safety Officer Jim Bailey at 804-640-6816.',
      continue: 'I am safe — continue to assistant',
    },
    errors: {
      title: 'Something went wrong',
      loadChats: 'Failed to load chats.',
      loadMessages: 'Failed to load messages.',
      createChat: 'Failed to create chat.',
      deleteChat: 'Failed to delete chat.',
      sendMessage: 'Failed to send message.',
      dismiss: 'Dismiss',
    },
  },
  adminPanel: {
    title: 'Admin Panel',
    subtitle: 'Manage documents, web pages, and review chat usage reports',
  },
  adminNav: {
    documents: 'Documents',
    webPages: 'Web pages',
    reports: 'Reports',
  },
  documentsView: {
    uploadFile: 'Upload',
    searchPlaceholder: 'Search...',
    name: 'Name',
    filename: 'Filename',
    type: 'Type',
    size: 'Size',
    uploadedOn: 'Uploaded on',
    uploadedBy: 'Uploaded by',
    actions: 'Actions',
    status: 'Status',
    delete: 'Delete',
    download: 'Download',
    downloadSuccess: 'Download started',
    downloadError: 'Failed to download document',
    refreshIndexing: 'Refresh indexing',
    indexSuccess: 'Indexing finished successfully',
    indexError: 'Failed to index document',
    uploadSuccess: 'Upload complete',
    uploadError: 'Upload failed',
    uploadedButIndexFailed: 'Document uploaded but indexing failed. You can retry indexing later.',
    deleteSuccess: 'Document deleted',
    deleteError: 'Failed to delete document',
    uploadDialog: {
      title: 'Upload file',
      description: 'Upload one document to index for your chatbot.',
      nameLabel: 'Name',
      upload: 'Upload',
      noFilesSelected: 'Select a file to upload.',
    },
  },
  webPagesView: {
    addWebPage: 'Add New Page',
    searchPlaceholder: 'Search...',
    name: 'Name',
    link: 'Link',
    addedOn: 'Added on',
    addedBy: 'Added by',
    actions: 'Actions',
    status: 'Status',
    delete: 'Delete',
    refreshIndexing: 'Refresh indexing',
    indexSuccess: 'Indexing finished successfully',
    indexError: 'Failed to index web page',
    createSuccess: 'Web page added',
    createError: 'Failed to add web page',
    loadedButIndexFailed: 'Web page loaded but indexing failed. You can retry indexing later.',
    deleteSuccess: 'Web page deleted',
    deleteError: 'Failed to delete web page',
    addDialog: {
      title: 'Add a webpage',
      description: 'Add web page to parse for your chatbot.',
      nameLabel: 'Name *',
      urlLabel: 'URL *',
      urlPlaceholder: 'example.com/docs',
      savedPageLabel: 'Saved page *',
      savedPageHint:
        'This site blocked a direct load. Open the page in your browser, then File → Save Page As → Webpage, HTML Only, and choose that file.',
      openInBrowser: 'Open in browser',
      savedPageType: 'Choose an .html file',
      savedPageTooLarge: 'Saved page is too large (max 5 MB)',
      savedPageEmpty: 'Saved page is empty',
    },
  },
  reportsView: {
    tabs: {
      registered: 'Registered users',
      anonymous: 'Anonymous users',
    },
    summary: {
      today: 'Chats today',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
    },
    columns: {
      date: 'Date',
      chatCount: 'Number of Chats',
      userName: 'User Name',
      chatName: 'Chat Name',
    },
    registered: {
      usersSubtitle: 'Registered users for this day',
    },
    anon: {
      chatsSubtitle: 'Anonymous chats for this day',
    },
    noMessages: 'No messages in this conversation.',
  },
}
